import React, {useState} from "react";
import {Button, Modal, Table} from "react-bootstrap";

const unknownLabel = "Не определено";

const HostItem = ({name, page, showPages}) => {
    if (!name) {
        return <span>{unknownLabel}</span>
    }

    const url = name.match(/^\w+:\/\//) ? name : `https://${name}`;

    if (page) {
        const handleClick = (e) => {
            e.preventDefault();
            if (page.length) {
                showPages(page);
            }
        }

        return <a href="#" onClick={handleClick}>{name}</a>
    }

    return <a href={url} target="_blank">{name}</a>
}

export default ({hosts}) => {
    const [pages, setPages] = useState([]);

    const showPages = (pages) => setPages(pages);
    const hidePages = () => setPages([]);

    const HostsTable = ({hosts}) => {
        return (
            <Table>
                <thead>
                <tr>
                    <th>Сайт</th>
                    <th style={{width: '20%', textAlign: 'right'}}>Зрители</th>
                </tr>
                </thead>
                <tbody>
                {hosts.map(({name, page, count}) => <tr key={name}>
                    <td style={{wordBreak: 'break-all'}}>
                        <HostItem name={name} page={page} showPages={showPages} />
                    </td>
                    <td style={{textAlign: 'right'}}>{count}</td>
                </tr>)}
                </tbody>
            </Table>
        );
    };

    if(!hosts.length) return null;

    return (
        <article>
            <HostsTable hosts={hosts} />

            <Modal show={pages.length > 0} onHide={hidePages} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Страницы</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <HostsTable hosts={pages} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={hidePages}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        </article>
    );
}
